
/**
 * Hard limit on an intake field name. Field names are written to
 * ClientPortalCustomFields.Name (nvarchar(512)) when a template is applied
 * to a ClientConnect portal, so anything longer fails at that point even
 * though the template itself saves fine in firm settings.
 */
export const MAX_INTAKE_FIELD_NAME_LENGTH = 512;

export const isIntakeFieldNameTooLong = (name: string): boolean =>
    (name ?? '').length > MAX_INTAKE_FIELD_NAME_LENGTH;

/** Names of fields in a template that exceed MAX_INTAKE_FIELD_NAME_LENGTH. */
export const getOverLimitIntakeFieldNames = (fieldSet: ClientConnectCustomFieldSet | null | undefined): string[] =>
    (fieldSet?.fields ?? []).map(f => f.name).filter(isIntakeFieldNameTooLong);

export type AutoApplyFileType = 'Purchase' | 'Sale' | 'Mortgage' | 'Family Transfer';

export const ALL_AUTO_APPLY_FILE_TYPES: AutoApplyFileType[] = ['Purchase', 'Sale', 'Mortgage', 'Family Transfer'];

export type ClientConnectCustomFieldSet = {
    fieldSetName: string;
    fields: CustomFields[];
    autoApplyFileTypes?: AutoApplyFileType[];
}

export type CustomFields = {
    name: string;
    type: string;
    perClient: boolean;
    value: string;
    fromSet: boolean;
    id: string;
    identifier?: string
}


export const defaultFieldSet: ClientConnectCustomFieldSet = {
    fieldSetName: '',
    fields: [
        {
            name: '',
            type: 'text',
            perClient: false,
            value: '',
            fromSet: false,
            id: '-1',
            identifier: ''
        }
    ],
    autoApplyFileTypes: [],
}